// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__2mZ5T","button":"style_button___lPxX","closeIssue":"style_closeIssue__2RhNF"};